import React from 'react';
import { Row,  } from 'antd';

import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import TextArea from 'antd/lib/input/TextArea';

const TabCancelProposal = () => (
  <Row>
    
    <FormInput col xs={24} lg={6} name="parvalue" comcode="cancelreason" rules={[{ required: true }]}>
      <ParListSelect parcode="PROPCANCEL" />
    </FormInput>
    
    <FormInput col xs={24} lg={24} name="comment" comcode="comment" rules={[{ required: true }]}>
      <TextArea rows={5} />
    </FormInput>
    
  </Row>
);

export default TabCancelProposal;
